import { ComponentRef, ViewContainerRef } from "@angular/core";
import { MultiFactorAuthSuccessComponent } from "./multi-factor-auth-success.component";


class MultiFactorAuthSuccessSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    multFactorAuthSuccessComponentRef: ComponentRef<MultiFactorAuthSuccessComponent>;

    constructor(formId: string, payload: object) {

        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {

      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.multFactorAuthSuccessComponentRef = this.viewContainerRef.createComponent(MultiFactorAuthSuccessComponent);
        this.multFactorAuthSuccessComponentRef.instance.emailAddress = this.clientContext['email_mfa'];
        this.multFactorAuthSuccessComponentRef.instance.recoveryNumber = this.clientContext['mobile_mfa'];

        this.multFactorAuthSuccessComponentRef.instance.onHomeLinkSubmit = this.onHomeLinkClick.bind(this);

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));

              this.submitBlock = null;
            } catch (e) {

              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {

      }

      onError(payload: object): void {

      }

      private onHomeLinkClick() {
        this.submitBlock(null);
      }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default MultiFactorAuthSuccessSession;
